<template>
    <b-container fluid class="p-0">
        <situacao-contrato :idContrato="contrato.IdContrato" />
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">
                        Detalhes do Contrato / Ordem de Fornecimento {{ contrato.NumeroAnoContrato }}
                    </span>
                    <btn-voltar />
                    <btn-excluir v-if="modoExclusao" :excluirItem="callExcluir" :idItem="1" botao
                        class="float-right mt-1" />
                </h6>
            </template>
            <b-tabs card fill>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" v-b-tooltip.hover title="Dados do Contrato / Ordem de Fornecimento" />
                        <span class="d-none d-md-inline">Dados iniciais</span>
                    </template>
                    <detalhes-dados-gerais-contrato :contrato="contrato"></detalhes-dados-gerais-contrato>
                </b-tab>
                <b-tab lazy>
                    <template #title>
                        <font-awesome-icon icon="users" class="mr-1 text-info" v-b-tooltip.hover title="Dados do Contrato / Ordem de Fornecimento" />
                        <span class="d-none d-md-inline">Contratados</span>
                    </template>
                    <detalhes-participantes-contrato :contrato=contrato></detalhes-participantes-contrato>
                </b-tab>
                <b-tab lazy>
                    <template #title>
                        <font-awesome-icon icon="hourglass-end" class="mr-1 text-secondary" v-b-tooltip.hover
                            title="Histórico" />
                        <span class="d-none d-md-inline">Histórico</span>
                    </template>
                    <detalhes-historico-contrato :idContrato="+idContrato"></detalhes-historico-contrato>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import DetalhesDadosGeraisContrato from '@/components/licitacoes/contratos/DetalhesDadosGeraisContrato.vue'
import DetalhesHistoricoContrato from '@/components/licitacoes/contratos/DetalhesHistoricoContrato.vue'
import DetalhesParticipantesContrato from '@/components/licitacoes/contratos/DetalhesParticipantesContrato.vue'
import SituacaoContrato from '@/components/licitacoes/contratos/SituacaoContrato.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import contratoService from '@/services/licitacoes/contratoService'
import { store } from "@/store"
import { fieldsLogsEventos } from '@/types/licitacoes/fields-logs-eventos'
import { LogEvento } from '@/types/licitacoes/log-evento'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import { Contrato } from '@/types/licitacoes/contratos/contrato'

const CompProps = Vue.extend({
    name: 'DetalhesContratosOF',
    components: {
        BtnExcluir, BtnVoltar, DetalhesDadosGeraisContrato, DetalhesParticipantesContrato, DetalhesHistoricoContrato, SituacaoContrato
    },
    props: {
        idContrato: {
            type: String,
            required: true
        }
    }
})


@Component
export default class DetalhesContratosOF extends mixins(UtilsTS, CompProps) {
    tableBusy = false
    contrato: Contrato = new Contrato()
    itemsLogs: LogEvento[] = []
    fieldsLogs: TableField[] = fieldsLogsEventos
    currentPageLogs = 1

    get modoExclusao() {
        return 'excluir' in this.$route.query
    }

    async mounted() {
        try {
            store.blockScreen = true
            this.contrato = await contratoService.buscarDadosGerais(this.idContrato)
            this.contrato.tratarDadosDaAPI()
        }
        catch (e: any) {
            console.error('Erro ao montar detalhes do contrato', e)
            this.$router.push("/modulo-licitacoes/contratos/contratos-ordens-fornecimento");
            this.$toast.error(e.message || "Erro ao carregar contrato");
        } finally {
            store.blockScreen = false
        }
    }

    async callExcluir() {
        try {
            store.blockScreen = true
            const response = await contratoService.removerContrato(+this.idContrato)
            if (response) {
                this.$toast.success('Contrato/O.F. excluído com sucesso')
                this.$router.push("/modulo-licitacoes/contratos/contratos-ordens-fornecimento");
            } else {
                this.$toast.error('Erro ao excluir Contrato/O.F.')
            }
        } catch (error: any) {
            this.tratarError(error)
        } finally {
            store.blockScreen = false
        }
    }

}
</script>

<style></style>